/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeEpubViewerData } from './moe-epub-viewer.data';
import { IMoeEpubViewerProps } from './moe-epub-viewer.props.autogenerated';

export interface IMoeEpubViewerViewProps extends IMoeEpubViewerProps<IMoeEpubViewerData> {}

/**
 *
 * MoeEpubViewer component
 * @extends {React.PureComponent<IMoeEpubViewerProps<IMoeEpubViewerData>>}
 */
class MoeEpubViewer extends React.PureComponent<IMoeEpubViewerProps<IMoeEpubViewerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeEpubViewer;
